@if (!isMobile()) {
  <div class="actions-header">
    <div class="actions-header__primary">
      <div class="actions-header__filters">
        @if (hasFilterFields) {
          <mat-form-field class="growing" appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ 'shared.filterFields' | translate }}</mat-label>
            <mat-select
              [multiple]="multipleOptions()"
              [ngModel]="selectedFilterFields"
              (ngModelChange)="updateSelectedFilterFields($event)"
              (selectionChange)="handleInputAndSelectionChange()"
            >
              @for (filterField of filterFields(); track filterField) {
                <mat-option value="{{ filterField.key }}"> {{ filterField.displayName | translate }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        @if (hasOperators()) {
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ 'shared.selectOperator' | translate }}</mat-label>
            <mat-select
              [ngModel]="selectedCompareOperator"
              (ngModelChange)="updateSelectedCompareOperator($event)"
              (selectionChange)="handleInputAndSelectionChange()"
            >
              @for (operator of compareOperators; track operator) {
                <mat-option value="{{ operator }}">
                  {{ 'shared.comparators.' + operator | translate }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        <ng-container *ngTemplateOutlet="$safeNavigationMigration(filtersDirective()?.templateRef)"></ng-container>
      </div>
      @if (hasSearchField()) {
        <div class="actions-header__search">
          <mat-form-field
            class="searchInput"
            (input)="handleInputAndSelectionChange()"
            appearance="outline"
            floatLabel="always"
            subscriptSizing="dynamic"
          >
            <input
              #searchInput
              [attr.data-testid]="searchInputTestId()"
              [placeholder]="'shared.search' | translate"
              [ngModel]="searchValue"
              (ngModelChange)="updateSearchValue($event)"
              matInput
              type="text"
            />
            <div matSuffix>
              <span class="icon icon-Search" (click)="handleInputAndSelectionChange()"></span>
              @if (searchValue) {
                <span class="icon icon-Close" (click)="clearSearch()"></span>
              }
            </div>
          </mat-form-field>
        </div>
      }
      <div class="actions-header__btns-container">
        @if (hasClearFiltersBtn) {
          <button class="btn btn-secondary btn-withIcon large" (click)="clearFilters()">
            <span class="icon icon-Close-big"></span>
            <span>{{ 'shared.clearFilters' | translate }}</span>
          </button>
        }
        <ng-container *ngTemplateOutlet="$safeNavigationMigration(contentDirective()?.templateRef)"></ng-container>
      </div>
    </div>
    @if (additionalFiltersDirective()?.templateRef) {
      <div class="actions-header__additional-filters">
        <ng-container *ngTemplateOutlet="$safeNavigationMigration(additionalFiltersDirective()?.templateRef)"></ng-container>
      </div>
    }
  </div>
} @else {
  <mat-accordion class="version1">
    @if (hasFilterFields || hasOperators() || filtersDirective()?.templateRef || additionalFiltersDirective()?.templateRef) {
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <span>{{ 'shared.filters.title' | translate }}</span>
        </mat-expansion-panel-header>
        <div class="actions-header__filters">
          @if (hasFilterFields) {
            <mat-form-field class="growing" appearance="outline" subscriptSizing="dynamic">
              <mat-label>{{ 'shared.filterFields' | translate }}</mat-label>
              <mat-select
                [multiple]="multipleOptions()"
                [ngModel]="selectedFilterFields"
                (ngModelChange)="updateSelectedFilterFields($event)"
                (selectionChange)="handleInputAndSelectionChange()"
              >
                @for (filterField of filterFields(); track filterField) {
                  <mat-option value="{{ filterField.key }}"> {{ filterField.displayName | translate }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          @if (hasOperators()) {
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <mat-label>{{ 'shared.selectOperator' | translate }}</mat-label>
              <mat-select
                [ngModel]="selectedCompareOperator"
                (ngModelChange)="updateSelectedCompareOperator($event)"
                (selectionChange)="handleInputAndSelectionChange()"
              >
                @for (operator of compareOperators; track operator) {
                  <mat-option value="{{ operator }}">
                    {{ 'shared.comparators.' + operator | translate }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          <ng-container *ngTemplateOutlet="$safeNavigationMigration(filtersDirective()?.templateRef)"></ng-container>
        </div>
        @if (additionalFiltersDirective()?.templateRef) {
          <div class="actions-header__additional-filters">
            <ng-container *ngTemplateOutlet="$safeNavigationMigration(additionalFiltersDirective()?.templateRef)"></ng-container>
          </div>
        }
      </mat-expansion-panel>
    }
    @if (hasClearFiltersBtn || contentDirective()?.templateRef) {
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <span>{{ 'shared.actions' | translate }}</span>
        </mat-expansion-panel-header>
        <div class="actions-header__btns-container">
          @if (hasClearFiltersBtn) {
            <button class="btn btn-secondary btn-withIcon large" (click)="clearFilters()">
              <span class="icon icon-Close-big"></span>
              <span>{{ 'shared.clearFilters' | translate }}</span>
            </button>
          }
          <ng-container *ngTemplateOutlet="$safeNavigationMigration(contentDirective()?.templateRef)"></ng-container>
        </div>
      </mat-expansion-panel>
    }
  </mat-accordion>
  @if (hasSearchField()) {
    <div class="actions-header__search">
      <mat-form-field
        class="searchInput"
        (input)="handleInputAndSelectionChange()"
        appearance="outline"
        floatLabel="always"
        subscriptSizing="dynamic"
      >
        <input
          #searchInput
          [attr.data-testid]="searchInputTestId()"
          [placeholder]="'shared.search' | translate"
          [ngModel]="searchValue"
          (ngModelChange)="updateSearchValue($event)"
          matInput
          type="text"
        />
        <div matSuffix>
          <span class="icon icon-Search" (click)="handleInputAndSelectionChange()"></span>
          @if (searchValue) {
            <span class="icon icon-Close" (click)="clearSearch()"></span>
          }
        </div>
      </mat-form-field>
    </div>
  }
}
